<template lang="pug">
a.hubsFilter__documents--front(:id="hub.id", @click="generateSearchUrl")
  .hubsFilter__type
    div
      img(src="../../../assets/images/anagrama_tirant_blanco.png")
      span {{ t("components.forms.hubs.type_form") }}
  .portada
    .d-flex.h-100.w-75.justify-content-center.align-items-center.flex-column
      h6.hubsFilter__name {{ hub.name }}
    span.hubsFilter__badge(:class="ambitClass()" v-if="showAmbit") {{ t(`components.forms.ambitos.${hubAmbit()}`) }}
  .bgHover
    .d-flex.justify-content-center.align-items-center
      p.pr-3 {{ t("components.forms.hubs.open_hub") }}
      i.fas.fa-arrow-right
    p {{ hub.total }} {{ t("components.forms.hubs.documents") }}
</template>

<script>
import mixins from "common/mixins.js";
import { mapState } from "vuex";

export default {
  name: "hub-card-vue",
  props: {
    hub: { type: Object, default: {} },
  },
  mixins: [mixins.translate],
  methods: {
    generateSearchUrl(){
      const baseUrl = this.hubShowUrl()
      const input_search_token = document.getElementById('general').value
      const params = new URLSearchParams()
      if (input_search_token) {
        params.append('search_token', input_search_token)
      }
      params.append('ambito_hub',this.calculateAmbitoHub())
      if(gon.materia_url_param){params.append('materia', gon.materia_url_param)}

      window.location.href = `${baseUrl}?${params}`;
    },
    ambitClass() {
      return this.selectedHubAmbit ? `badge-${this.selectedHubAmbit}` : `badge-${this.hub.ambitos[0]}`;
    },
    hubAmbit() {
      if (this.isModelosOficiales) {
          return this.hasFinancieroTributarioSubject() ? 'financiero-tributario' : 'default';
      }
      return this.selectedHubAmbit || this.hub.ambitos[0];
    },
    calculateAmbitoHub(){
      return this.modelosOficialesWithAmbitSelected ? this.selectedAmbitsAsUrlParam() : this.hubAmbit()
    },
    selectedAmbitsAsUrlParam(){
      return encodeURIComponent(this.ambitsSelected.join(','))
    },
    hubShowUrl(){
      return this.fromTemas ?
        gon.url_for.materias_indice_path.replace(':id',this.hub.id) :
        gon.url_for.hubs_indice_path.replace(':id',this.hub.id)
    },
    hasFinancieroTributarioSubject(){
      return gon.materia && gon.materia.translate_name == 'financiero y tributario'
    }
  },

  computed: {
    isModelosOficiales(){
      return this.hub.id == 'modelos-oficiales'
    },
    selectedHubAmbit() {
      return this.hub.ambitos.find(ambit => this.ambitsSelected.includes(ambit));
    },
    ambitsAreSelected(){
      return this.ambitsSelected.length > 0
    },
    modelosOficialesWithAmbitSelected(){
      return this.isModelosOficiales && this.ambitsAreSelected
    },
    showAmbit(){
      if(this.isModelosOficiales){
        if(this.hasFinancieroTributarioSubject())
          return true
        return false
      }else if(this.hub.ambitos.length > 0){
        return true
      }
      return false
    },
    ...mapState("hub_search", ["ambitsSelected", "fromTemas"]),
  }
};
</script>
